module.exports = __webpack_public_path__ + "d33c25d058ec25f12a1cb78b3b4a976e.svg";